// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QQpKy__nav {
  flex: 1;
  margin: 0.5em 1em 0.5em 0;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 0.4em;
}

@media screen and (min-width: 430px) {

.QQpKy__nav {
    gap: 0.6em;
}
  }

.QQpKy__nav > * {
    position: relative;
    z-index: 15;
  }

.oWhzE__pillButton {
  font-size: 0.7em !important;
  padding: 0.3em 0.7em !important;
}

.oWhzE__pillButton {
  border-radius: 12px;
  border: 1px solid transparent;
}

@media screen and (min-width: 768px) {

.oWhzE__pillButton {
    font-size: 0.9em !important;
}
  }

.oWhzE__pillButton.k20NQ__mapButton {
    color: white !important;
  }

.oWhzE__pillButton.k20NQ__mapButton {
    background: var(--color-purple-1);
  }

.oWhzE__pillButton.k20NQ__mapButton:active {
      color: white !important;
    }

.oWhzE__pillButton.k20NQ__mapButton:active {
      background: var(--color-purple-0);
    }

.oWhzE__pillButton.k20NQ__mapButton.gGCzL__active {
      color: var(--color-purple-1) !important;
    }

.oWhzE__pillButton.k20NQ__mapButton.gGCzL__active {
      border-color: var(--color-purple-1);
      background: white;
    }

.oWhzE__pillButton.qA6hM__aboutButton {
    background: var(--color-blue-1) !important;
    color: white !important;
  }

.oWhzE__pillButton.qA6hM__aboutButton:active {
      background: var(--color-blue-0) !important;
      color: white !important;
    }

.oWhzE__pillButton.qA6hM__aboutButton.gGCzL__active {
      border: 1px solid var(--color-blue-1) !important;
      background: white !important;
      color: var(--color-blue-1) !important;
    }

.oWhzE__pillButton.uByaM__loginButton {
    color: white !important;
  }

.oWhzE__pillButton.uByaM__loginButton {
    background: var(--color-grey-5);
  }

.pLd7O__buttonIcon {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.pLd7O__buttonIcon span {
    position: absolute;
    bottom: -1.5em;
    font-weight: 300;
    font-size: 0.6em;
  }
`, "",{"version":3,"sources":["webpack://./src/app/Navigation/TopNav.module.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;AAUZ;;AARE;;AAVF;IAWI,UAAU;AAOd;EANE;;AAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;AAGF;EAGE,2BAA2B;EAC3B,+BAA+B;AAsCjC;;AA1CA;EACE,mBAAmB;EACnB,6BAA6B;AAwC/B;;AApCE;;AANF;IAOI,2BAA2B;AAmC/B;EAlCE;;AAEA;IAEE,uBAAuB;EAUzB;;AAZA;IACE,iCAAiC;EAWnC;;AATE;MAEE,uBAAuB;IACzB;;AAHA;MACE,iCAAiC;IAEnC;;AACA;MAGE,uCAAuC;IACzC;;AAJA;MACE,mCAAmC;MACnC,iBAAiB;IAEnB;;AAGF;IACE,0CAA0C;IAC1C,uBAAuB;EAUzB;;AATE;MACE,0CAA0C;MAC1C,uBAAuB;IACzB;;AACA;MACE,gDAAgD;MAChD,4BAA4B;MAC5B,qCAAqC;IACvC;;AAGF;IAEE,uBAAuB;EACzB;;AAHA;IACE,+BAA+B;EAEjC;;AAGF;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AAOzB;;AANE;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB","sourcesContent":[".nav {\n  flex: 1;\n  margin: 0.5em 1em 0.5em 0;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.4em;\n\n  @media (--screen-sm) {\n    gap: 0.6em;\n  }\n\n  & > * {\n    position: relative;\n    z-index: 15;\n  }\n}\n\n.pillButton {\n  border-radius: 12px;\n  border: 1px solid transparent;\n  font-size: 0.7em !important;\n  padding: 0.3em 0.7em !important;\n\n  @media (--screen-md) {\n    font-size: 0.9em !important;\n  }\n\n  &.mapButton {\n    background: var(--color-purple-1);\n    color: white !important;\n    &:active {\n      background: var(--color-purple-0);\n      color: white !important;\n    }\n    &.active {\n      border-color: var(--color-purple-1);\n      background: white;\n      color: var(--color-purple-1) !important;\n    }\n  }\n\n  &.aboutButton {\n    background: var(--color-blue-1) !important;\n    color: white !important;\n    &:active {\n      background: var(--color-blue-0) !important;\n      color: white !important;\n    }\n    &.active {\n      border: 1px solid var(--color-blue-1) !important;\n      background: white !important;\n      color: var(--color-blue-1) !important;\n    }\n  }\n\n  &.loginButton {\n    background: var(--color-grey-5);\n    color: white !important;\n  }\n}\n\n.buttonIcon {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  & span {\n    position: absolute;\n    bottom: -1.5em;\n    font-weight: 300;\n    font-size: 0.6em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav": `QQpKy__nav`,
	"pillButton": `oWhzE__pillButton`,
	"mapButton": `k20NQ__mapButton`,
	"active": `gGCzL__active`,
	"aboutButton": `qA6hM__aboutButton`,
	"loginButton": `uByaM__loginButton`,
	"buttonIcon": `pLd7O__buttonIcon`
};
export default ___CSS_LOADER_EXPORT___;
